/* UNEND: video do banner da home com foto de abertura (sections/slideshow.liquid, bloco Video).
   A foto (picture.unend-video-capa) fica embaixo do video. O video so aparece por cima quando ja esta rodando e passou
   do segundo em que a foto foi tirada. Antes disso (carregando, quadro cinza do comeco do video, ou parado porque o
   navegador nao deixou tocar sozinho, como no modo economia do iPhone) a pessoa ve a foto. */
(() => {
  const ligar = (raiz) => {
    raiz.querySelectorAll('video-media.unend-video-com-capa').forEach((midia) => {
      if (midia.dataset.unendCapa) return;
      const video = midia.querySelector('video');
      if (!video) return;
      midia.dataset.unendCapa = '1';

      const capa = midia.parentElement ? midia.parentElement.querySelector('.unend-video-capa') : null;
      const celular = midia.classList.contains('sm:hidden');
      const valor = capa ? (celular ? capa.dataset.segundoCelular : capa.dataset.segundo) : '0';
      const limite = Math.max(parseFloat(valor) || 0, 0.05);

      const atualizar = () => {
        const rodando = video.readyState >= 2 && video.currentTime >= limite;
        midia.classList.toggle('is-unend-rodando', rodando);
      };

      ['loadeddata', 'playing', 'timeupdate', 'seeked', 'emptied'].forEach((evento) => {
        video.addEventListener(evento, atualizar);
      });
      atualizar();
    });
  };

  ligar(document);
  document.addEventListener('shopify:section:load', (evento) => ligar(evento.target));
})();
